import React from 'react';
import { motion } from 'framer-motion';

const pageVariants = {
    initial: {
        opacity: 0,
    },
    animate: {
        opacity: 1,
        transition: {
            duration: 0.6,
            ease: [0.22, 1, 0.36, 1], // Custom Zen Cubic Bezier
        },
    },
    exit: {
        opacity: 0,
        transition: {
            duration: 0.4,
            ease: "easeIn",
        },
    },
};

const ZenPageTransition = ({ children }) => {
    return (
        <motion.div
            initial="initial"
            animate="animate"
            exit="exit"
            variants={pageVariants}
            className="w-full h-full"
        >
            {children}
        </motion.div>
    );
};

export default ZenPageTransition;
